export default [
    {
      path: "seller-agreement",
      name: "seller-agreement",
      component: () => import("@/views/seller-agreement/Index"),
      meta: {
        nextable: true,
      },
    },
  ];